import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const FAQ = () => {
  const initialState = {
    name: "",
    email: "",
    address: "",
    phone: "",
    message: "",
  };
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log(formData);
  };
  const handleReset = () => {
    setFormData(initialState);
  };
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>FAQ</h1>
        <Row className="mt-4">
          <h2>Interested in Discussing</h2>
          <Container className="mt-2">
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={5}>
                  <Form.Group className="mb-3" controlId="formName">
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email *</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={5}>
                  <Form.Group className="mb-3" controlId="formAddress">
                    <Form.Label>Address *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group className="mb-3" controlId="formPhone">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="phone"
                      placeholder="Enter Phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={10}>
                  <Form.Group className="mb-3" controlId="formMessage">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button type="button" className="btn btn-primary" size="md">
                Send Your Message
              </Button>
              <Button
                size="md"
                type="button"
                className="btn btn-secondary ms-3"
                onClick={handleReset}
              >
                Reset
              </Button>
            </Form>
          </Container>
        </Row>
      </section>
    </>
  );
};

export default FAQ;
